import type { TConfigurationCreateBody, TConfigurationUpdateBody } from "types/directoryConfiguration";

import { useQueryClient } from "@tanstack/react-query";
import {
  syncDirectory as apiSyncDirectory,
  createDirectoryConfiguration,
  deleteDirectoryConfiguration,
  editDirectoryConfiguration,
} from "api/directoryConfigurations";
import constate from "constate";
import { directoryConfigurationsQuery } from "queries/directoryConfigurationsQueries";
import { useCallback } from "react";

// This context is legacy code! Once the old configuration modal is no longer in use it can be removed
const useLegacyDirectoryConfigurations = () => {
  const queryClient = useQueryClient();

  const invalidateDirectoryConfigurationsQuery = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: directoryConfigurationsQuery().queryKey });
  }, [queryClient]);

  const createConfiguration = useCallback(
    async (data: TConfigurationCreateBody) => {
      await createDirectoryConfiguration(data);
      invalidateDirectoryConfigurationsQuery();
    },
    [invalidateDirectoryConfigurationsQuery],
  );

  const syncDirectory = useCallback(
    async (id: string) => {
      await apiSyncDirectory(id);
      invalidateDirectoryConfigurationsQuery();
    },
    [invalidateDirectoryConfigurationsQuery],
  );

  const updateConfiguration = useCallback(
    async (id: string, data: TConfigurationUpdateBody) => {
      await editDirectoryConfiguration(id, data);
      invalidateDirectoryConfigurationsQuery();
    },
    [invalidateDirectoryConfigurationsQuery],
  );

  const deleteConfiguration = useCallback(
    async (id: string) => {
      await deleteDirectoryConfiguration(id);
      invalidateDirectoryConfigurationsQuery();
    },
    [invalidateDirectoryConfigurationsQuery],
  );

  return {
    actions: {
      createConfiguration,
      deleteConfiguration,
      syncDirectory,
      updateConfiguration,
    },
  };
};

export const [LegacyDirectoryConfigurationsProvider, useLegacyDirectoryConfigurationsContext] = constate(
  useLegacyDirectoryConfigurations,
);
